import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';
import { MODULE_ACCESS_ERRORS, getModuleAccessMessage } from "../helpers/moduleAccess";

const toastError = err => {
	const errorMsg = err.response?.data?.error;
	const showError = (message, toastId = message) => {
		toast.error(message, {
			toastId,
			autoClose: 2000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: false,
			draggable: true,
			progress: undefined,
			theme: "light",
		});
	};

	const accessCode = errorMsg || (isString(err) ? err : null);
	if (MODULE_ACCESS_ERRORS.includes(accessCode)) {
		showError(getModuleAccessMessage(accessCode), accessCode);
		return;
	}

	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			showError(i18n.t(`backendErrors.${errorMsg}`), errorMsg);
			return
		} else {
			showError(errorMsg);
			return
		}
	} if (isString(err)) {
		if (i18n.exists(`backendErrors.${err}`)) {
			showError(i18n.t(`backendErrors.${err}`), err);
		} else {
			toast.error(err);
		}
		return
	} else {
		toast.error("An error occurred!");
		return
	}
};

export default toastError;
